import React from 'react'
import ItemTypes from '../lib/item_types'

export default  class RowSettings extends React.Component {

  static type = ItemTypes.ROW

  onChange = (e) => {
    let quantityCells = parseInt(e.target.value)

    if (quantityCells > 12) { quantityCells = 12 }
    else if (quantityCells < 1) { quantityCells = 1 }

    const row = this.props.item
    if (row.cells.length == quantityCells) { return }
    if (!isNaN(quantityCells)) {
      // Rows from the store are frozen by Immer — update a copy, don't mutate.
      const cells = (row.cells.length > quantityCells)
        ? row.cells.slice(0, -1)
        : row.cells.concat([ItemTypes.CELL.initStruct])
      this.updateItem(Object.assign({}, row, { cells }))
    }
  }

  updateItem = (data) => {
    this.props.handlers.updateItem(ItemTypes.ROW.type, data, this.props.path)
  }

  render () {
    const row = this.props.item
    return (
      <div className="row-settings">
        <div className="form-group">
          <label className="label">Cells</label>
          <div className="default-form-input-wrapper">
            <input type="number" className="form-control q-cells-field" min="1" max="12" name="cells" value={row.cells.length} onChange={this.onChange} />
          </div>
        </div>
      </div>
    )
  }
}
